(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bam-browser-sdk"));
	else if(typeof define === 'function' && define.amd)
		define(["bam-browser-sdk"], factory);
	else if(typeof exports === 'object')
		exports["bam-browser-sdk-sdkSession-util"] = factory(require("bam-browser-sdk"));
	else
		root["bam-browser-sdk-sdkSession-util"] = factory(root["bam-browser-sdk"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition